<template>
  <div>
    <Head title="Vlerësimet & Sygjerimet" />
    <h1 class="mb-8 text-3xl font-bold">Gjithmonë presim kritika dhe vlerësime nga ana juaj!</h1>


    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Shërbimi:</label>
        <select v-model="form.service_id" class="form-select mt-1 w-full">
          <option :value="null">Të gjitha</option>
          <option v-for="service in services" :value="service.id">{{ service.name }}</option>
        </select>

        <label class="block text-gray-700">Nota:</label>
        <select v-model="form.rate_id" class="form-select mt-1 w-full">
          <option :value="null">Të gjitha</option>
          <option v-for="rate in rates" :value="rate.id">{{ rate.name }}</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="vleresimet/regjistro">
        <span>Na vlerëso</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-2"></th>
          <th class="pb-4 pt-6 px-2">Shërbimi</th>
          <th class="pb-4 pt-6 px-2">Qytetet</th>
          <th class="pb-4 pt-6 px-2">Vlerësimi</th>
          <th class="pb-4 pt-6 px-2">Sygjerimi</th>
          <th class="pb-4 pt-6 px-2">Krijuar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="review in reviews.data" :key="review.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="w-px border-t  px-2">
            <Link class="flex items-center px-4  py-4" :href="`vleresimet/${review.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t px-2">
              {{ review.service }}
          </td>
          <td class="border-t px-2">
              <span class="mx-0.5 px-2 py-1 bg-indigo-100 rounded-md" v-for="city in  review.cities ">{{city.name}}</span>
          </td>
          <td class="border-t  px-2">
              {{ review.rate }}
          </td>
          <td class="border-t  px-2">
              {{ review.suggestion }}
          </td>
          <td class="border-t  px-2">
              {{ review.hr_created_at }}
          </td>
          <td class="w-px border-t">

            <dropdown class="mt-1" placement="bottom-end">
              <template #default>
                <icon name="three-dots" class="block w-12 h-6 fill-gray-400"/>
              </template>
              <template #dropdown>
                <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                  <button v-if="!review.deleted_at" class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" tabindex="-1" type="button" @click="destroy(review.id)">Fshij</button>
                </div>
              </template>
            </dropdown>
          </td>
        </tr>
        <tr v-if="reviews.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnje vlerësim.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="reviews.meta.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'
import SearchInput from '@/Shared/SearchInput'
import SearchFilter from '@/Shared/SearchFilter'
import Dropdown from '@/Shared/Dropdown'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    DangerFlashMessage,
    SearchInput,
    SearchFilter,
    Dropdown
  },
  layout: Layout,
  props: {
    reviews: Object,
    filters: Object,
    services: Object,
    rates: Object
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        service_id: this.filters.service_id,
        rate_id: this.filters.rate_id
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/vleresimet', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    destroy(reviewId) {
      if (confirm('A jeni të sigurt?')) {
        this.$inertia.delete(`/vleresimet/${reviewId}`)
      }
    },
  },
  mounted() {
  }
}
</script>
